import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clock"
export default class extends Controller {
  static targets = ['time', 'day']
  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const now = new Date()

    // Hour HH:mm:ss
    const hh = String(now.getHours()).padStart(2, "0")
    const mm = String(now.getMinutes()).padStart(2, "0")
    const ss = String(now.getSeconds()).padStart(2, "0")
    this.timeTarget.textContent = `${hh}:${mm}:${ss}`

    // Days in japan
    const days = ["日", "月", "火", "水", "木", "金", "土"]
    this.dayTarget.textContent = `(${days[now.getDay()]})`
  }
}
